import { ChannelTypeEnum } from "../types";
import {
  WECOM_ACCOUNT_WS_ADDRESS,
  WECOM_CHAT_WS_ADDRESS,
  WECOM_CONTACT_WS_ADDRESS,
} from "../constants";
import { wsHandler } from "../handler/wecom/ws-handler";
import chatSdkHooks from "../hooks";
import { WebSocketClient } from "./ws";

export const wecomAccountWsClient = new WebSocketClient({
  wsAddress: WECOM_ACCOUNT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const wecomChatWsClient = new WebSocketClient({
  wsAddress: WECOM_CHAT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const wecomContactWsClient = new WebSocketClient({
  wsAddress: WECOM_CONTACT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wecom,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
